<template>
  <div
    v-if="visible"
    class="old-version-banner d-flex align-items-center justify-content-center">
    <span class="banner-text">
      Giao diện cũ của <strong>Salework Zalo</strong> sẽ ngừng hoạt động từ ngày
      <strong class="banner-date">{{ SHUTDOWN_DATE }}</strong>. Vui lòng chuyển sang giao diện mới để tiếp tục sử dụng.
      <span
        class="banner-action ms-1 fw-semibold"
        @click="switchToNew">
        Chuyển sang giao diện mới
      </span>
    </span>
    <i
      class="el-icon-close banner-close pointer"
      @click="dismiss" />
  </div>
</template>

<script>
import { NEW_VERSION_URL, SHUTDOWN_DATE } from "@/lib/old-version-notice";

export default {
  name: "OldVersionBanner",
  data() {
    return {
      visible: true,
      SHUTDOWN_DATE
    };
  },
  methods: {
    switchToNew() {
      window.location.href = NEW_VERSION_URL;
    },
    dismiss() {
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.old-version-banner {
  position: relative;
  height: 32px;
  padding: 0 48px 0 16px;
  background: #EAF0FC;
  /* border-bottom: 1px solid #FDE4A6; */
  color: black;
  z-index: 100;
}
.banner-text {
  text-align: center;
  font-size: 13px;
}
.banner-date {
  color: #C8372D;
}
.banner-action {
  color: #0A58C0;
  cursor: pointer;
  text-decoration: none;
}
.banner-action:hover {
  text-decoration: underline;
}
.banner-close {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #696B72;
}
.banner-close:hover {
  color: #081B3A;
}
</style>
